module.exports = __webpack_public_path__ + "img/leden-group.26ef22b5.gif";